export default "__VITE_ASSET__DnAQv3dt__"